import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/internal/Subscription';

import { Teacher } from '@app/definitions/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { AccountService } from '@app/teacher/services/account.service';

@Component({
    selector: 'app-prepare-class-list',
    templateUrl: './prepare-class-list.component.html',
    styleUrls: ['./prepare-class-list.component.scss']
})
export class PrepareClassListComponent implements OnInit, OnDestroy {
    teacher: Teacher;
    classId: number;
    private routeDataSubscription: Subscription;
    private routeParamsSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private teacherService: TeacherService,
        private accountService: AccountService
    ) {}

    public ngOnInit(): void {
        this.routeDataSubscription = this.accountService.$currentTeacher.subscribe((teacher: Teacher) => {
            this.teacher = teacher;
        });
        this.routeParamsSubscription = this.route.parent.params.subscribe(params => {
            this.classId = +params['class_id'];
            this.teacherService.setClassId(this.classId);
        });
    }

    public ngOnDestroy(): void {
        this.routeParamsSubscription.unsubscribe();
        this.routeDataSubscription.unsubscribe();
    }
}
